// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HistoryUI_wrapper__j\\+Xrc {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.HistoryUI_header__digGW {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.HistoryUI_back__tWm0x {
  display: flex;
  align-items: center;
  color: var(--orange);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 26px;
}

.HistoryUI_loader__j3ecf {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.HistoryUI_back__tWm0x:hover {
  color: var(--orange);
}

.HistoryUI_backButton__\\+p1oB {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--orange);
  color: white;
  margin-right: 15px;
}

.HistoryUI_orders__HuGLo {
  margin-top: 30px;
}

.HistoryUI_search__CvnUb {
  width: 200px;
  margin-right: 15px;
}

.HistoryUI_input__l7nUB button {
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  border-color: #c9c9c9;
}

.HistoryUI_input__l7nUB input {
  color: #7e7e7e !important;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
  border-color: #c9c9c9;
}

.HistoryUI_picker__TCedG {
  border-color: #c9c9c9;
  border-radius: 5px !important;
  margin-right: 15px;
}

.HistoryUI_preparationIcon__MqARX {
  width: 20px;
  height: 20px;
}

.HistoryUI_eye__NvOBO {
  background-color: transparent;
  color: var(--orange);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;
}

.HistoryUI_eye__NvOBO svg {
  width: 22px;
  height: 22px;
}

.HistoryUI_activeOrder__HYPqv{
  background-color: var(--orange);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/pages/history/styles/HistoryUI.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd","sourcesContent":[".wrapper {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.back {\n  display: flex;\n  align-items: center;\n  color: var(--orange);\n  font-family: BebasNeue;\n  font-weight: 700;\n  font-size: 26px;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.back:hover {\n  color: var(--orange);\n}\n\n.backButton {\n  width: 30px;\n  height: 30px;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--orange);\n  color: white;\n  margin-right: 15px;\n}\n\n.orders {\n  margin-top: 30px;\n}\n\n.search {\n  width: 200px;\n  margin-right: 15px;\n}\n\n.input button {\n  border-top-right-radius: 5px !important;\n  border-bottom-right-radius: 5px !important;\n  border-color: #c9c9c9;\n}\n\n.input input {\n  color: #7e7e7e !important;\n  border-top-left-radius: 5px !important;\n  border-bottom-left-radius: 5px !important;\n  border-color: #c9c9c9;\n}\n\n.picker {\n  border-color: #c9c9c9;\n  border-radius: 5px !important;\n  margin-right: 15px;\n}\n\n.preparationIcon {\n  width: 20px;\n  height: 20px;\n}\n\n.eye {\n  background-color: transparent;\n  color: var(--orange);\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  cursor: pointer;\n}\n\n.eye svg {\n  width: 22px;\n  height: 22px;\n}\n\n.activeOrder{\n  background-color: var(--orange);\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `HistoryUI_wrapper__j+Xrc`,
	"header": `HistoryUI_header__digGW`,
	"back": `HistoryUI_back__tWm0x`,
	"loader": `HistoryUI_loader__j3ecf`,
	"backButton": `HistoryUI_backButton__+p1oB`,
	"orders": `HistoryUI_orders__HuGLo`,
	"search": `HistoryUI_search__CvnUb`,
	"input": `HistoryUI_input__l7nUB`,
	"picker": `HistoryUI_picker__TCedG`,
	"preparationIcon": `HistoryUI_preparationIcon__MqARX`,
	"eye": `HistoryUI_eye__NvOBO`,
	"activeOrder": `HistoryUI_activeOrder__HYPqv`
};
export default ___CSS_LOADER_EXPORT___;
